import "../styles/default.scss";

import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import {
  buildAutomaticStrategySignalsHref,
  VIEW_ALL_STRATEGY_SIGNALS_LABEL_KEY
} from "../../../../../lib/automaticStrategySignalsNavigation";
import resolveStrategyDescriptionPlaceholders from "../../../../../lib/resolveStrategyDescriptionPlaceholders";
import withUserData from "../../../../../hocs/withUserData";
import resolveAutomaticStrategyPermissions from "../../../../../redux/modules/auth/userPermissions/utils/resolveAutomaticStrategyPermissions";
import NoAccessDisclaimer from "../../NoAccessDisclaimer";
import SquaberButton from "../../SquaberButton";
import { AdapterSquaberLink } from "../../SquaberLink/modules/default";

@withUserData
class AutomaticTransactionSignal extends React.Component {
  static propTypes = {
    strategy: PropTypes.object,
    ticker: PropTypes.string,
    market: PropTypes.string,
    stockName: PropTypes.string,
    shortName: PropTypes.string
  };

  render() {
    const {
      strategy,
      translate,
      hasPermission,
      locale,
      ticker,
      market,
      stockName,
      shortName
    } = this.props;

    const userHasAccess = hasPermission(
      resolveAutomaticStrategyPermissions(strategy.notifications_unique_id)
    );
    const moreHref = buildAutomaticStrategySignalsHref({
      locale,
      notificationsUniqueId: strategy.notifications_unique_id,
      ticker,
      market
    });
    const description = resolveStrategyDescriptionPlaceholders(
      strategy.description,
      {
        stock_name: stockName,
        short_name: shortName,
        ticker,
        market
      }
    );

    return (
      <div
        className={classNames({
          "automatic-transation-signal": true,
          [strategy.notifications_unique_id]: true,
          blurred: !userHasAccess
        })}
      >
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {!userHasAccess ? <NoAccessDisclaimer /> : null}
        {userHasAccess && moreHref ? (
          <div className="button-wrapper">
            <SquaberButton component={AdapterSquaberLink} to={moreHref}>
              {translate(VIEW_ALL_STRATEGY_SIGNALS_LABEL_KEY)}
            </SquaberButton>
          </div>
        ) : null}
      </div>
    );
  }
}

export default AutomaticTransactionSignal;
